import React from 'react'
import {getIntervalParser} from '../../shared/enums/interval-enum-parser'

export default React.createClass({
  getInitialState: function () {
    let packageTypeIndex, intervalTypeIndex, scheduleTypeIndex
    if(this.props.packageType) {
      if(this.props.packageType === 'basic') {
      packageTypeIndex = 0
    }
    else {
      packageTypeIndex = 1
    }
    return {selected: this.props.index === packageTypeIndex}
  }
  else if(this.props.intervalType) {
    if(this.props.intervalType === 'WEEKLY') {
      intervalTypeIndex = 0
    }
    else {
      intervalTypeIndex = 1
    }
    return {selected: this.props.index === intervalTypeIndex}
  }
  else if(this.props.scheduleType) {
    if(this.props.scheduleType.toUpperCase() === 'TASKEASY SCHEDULE') {
      scheduleTypeIndex = 0
    }
    else {
      scheduleTypeIndex = 1
    }
    return {selected: this.props.index === scheduleTypeIndex}
  }
    return {selected: this.props.index === 0}
  },
  handleClick: function () {
    this.props.handler(this.props.index)
  },

  render: function () {
    let serverPath = '/common/latest/images/consumer/order-process-icons/'
    let image = (serverPath + this.props.imageRoot + '.png').toLowerCase()
    let labelColor = 'medium-gray-color'
    let shadow = 'rgba(0, 0, 0, 0.3) 0px 1px 3px 0px';
    if(this.state){
      if (this.state.selected) {
      if(image.includes('star')) {
        let fixedIconName = this.props.imageRoot.replace("-gray", '')
        image = (serverPath + fixedIconName + '-blue.png').toLowerCase()
        shadow = 'rgba(0, 0, 0, 0.3) 2px 2px 7px 2px'
      }else {
        image = (serverPath + this.props.imageRoot + '-blue.png').toLowerCase()
        labelColor = 'cerulean-blue-color'
        shadow = 'rgba(0, 0, 0, 0.3) 2px 2px 7px 2px'
      }
    }
    }



    let padMe;
    let label = this.props.imageRoot
    let imgStyles=[];
    if(label.includes('star')) {
      if(label === 'one-star-gray') {
        label =
        <div style={{color: {labelColor}}}>
          <h6 style={{fontSize: 15}}>Budget</h6>
        </div>
        imgStyles = {
          width: '30px',
          height: '27px'
        }
        padMe = 15
      }
      else {
        label =
        <div style={{color: {labelColor}}}>
          <h6 style={{fontSize: 15}}>Full Service</h6>
        </div>
        imgStyles = {
          width: '80px',
          height: '27px',
          position: 'relative',
        }
          padMe = 15
      }
    }
    else if(label === 'checkmark') {
      label =
       <div style={{color: {labelColor}}}>
         <h6 style={{fontSize: 15}}>TaskEasy</h6>
        <h6 style={{fontSize: 15, position: 'relative', top: -8}}>Schedule</h6>
      </div>
      imgStyles = {
          width: '46px',
          height: '40px',
          position: 'relative',
        }
          padMe = 5
    }
    else if(label === 'my-schedule') {
      label =
       <div style={{color: {labelColor}}}>
        <h6 style={{fontSize: 15}}>My Own</h6>
        <h6 style={{fontSize: 15, position: 'relative', top: -8}}>Schedule</h6>
      </div>
      imgStyles = {
          width: '40px',
          height: '40px',
          position: 'relative',
        }
          padMe = 5
    }
    else {

      let newLabel = getIntervalParser(this.props.imageRoot.replace('-', '_')).capitalizedText
      label =
      <div style={{color: {labelColor}}}>
          <h6 style={{fontSize: 15}}>{newLabel}</h6>
        </div>
      imgStyles = {
          width: '45px',
          height: '45px',
          position: 'relative'
        }
        padMe = 15
        if (this.props.useLableAsImageSrc) {
          image = (serverPath + newLabel + '.png').toLowerCase()
        }
    }


    return (
      <span className={this.props.classList} onClick={this.handleClick}>
        <label className='btn btn-default custom-radio-button fixed-button' style={{paddingTop: padMe, boxShadow: shadow, border: 0}}>
          <input type='radio' name='options' />
          <img alt={label} src={image} style={imgStyles} />
          {label}
        </label>
      </span>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/components/custom-task-button.jsx